import { Observable } from 'rxjs'
// actions
// import { dataFrontendError } from '@weblite/action/errors'
// helper
// import { send } from '$setup/ws'
import { nothing } from './utils'
// import { getClientUserId } from '$logic/client-user'

export const useObservable = func$ => {
  let onNext = nothing
  const obs = func$(
    new Observable(subscriber => {
      onNext = (...args) => subscriber.next(...args)
    }),
  )
  obs.subscribe(nothing)

  return onNext
}

export const catchErrors = handler => async (...args) => {
  try {
    return await handler(...args)
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e)
    // send(dataFrontendError({ message: e, userId: getClientUserId() }), true, 50)
  }
  return null
}
